/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import "./LargeStat.scss";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import { Card, Grid, Tooltip } from "@material-ui/core";
import ContextualLayers from "../ContextualLayers/ContextualLayers";

function LargeStat(props) {
  const {
    item,
    handleStatClick,
    selectedStat,
    stats,
    country,
    layersToInclude,
    layersEnabled,
    handleLayerToggle,
  } = props;
  
  return (
    <Card
      className={`large-stat-card ${
        selectedStat && (item.name === selectedStat || item.id === selectedStat)
          ? "selected"
          : ""
      }
      ${handleStatClick ? "clickable" : ""}
      ${!handleStatClick ? "not-clickable" : ""}
      `}
      onClick={() => handleStatClick && handleStatClick(item)}
      variant="outlined"
    >
      <Grid container className="stat-wrapper" spacing={0}>
        <Grid item xs={11}>
          <Grid container className="value-wrapper" spacing={0}>
            <Grid item xs={12} className="stat-title">
              {item.title}
            </Grid>
            <Grid item xs={12} className="stat-value">
              {item.measurement && item.measurement === "$"
                ? item.measurement
                : null}
              {stats ? stats[item.name][country] : item[country]}{" "}
              {item.measurement && item.measurement !== "$" ? (
                <span className="measurement">{item.measurement}</span>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
        <Grid className="info-wrapper" item xs={1}>
          <Tooltip arrow title={item.tooltip}>
            <InfoIcon className="info-icon" />
          </Tooltip>
        </Grid>
        {selectedStat &&
          (item.name === selectedStat || item.id === selectedStat) &&
          layersToInclude &&
          layersToInclude.length > 1 && (
            <Grid item xs={12}>
              <ContextualLayers
                layersToInclude={layersToInclude}
                selectedStat={selectedStat}
                layersEnabled={layersEnabled}
                handleLayerToggle={handleLayerToggle}
              />
            </Grid>
          )}
      </Grid>

      {/* <div className="infoPanel">
          <Tooltip title={item.tooltip}>
            <InfoIcon className="info-icon" />
          </Tooltip>
        </div>
        <div className="statName">{item.title}</div>
        <div className="statValue">
          {stats ? stats[item.name][country] : item[country]}{" "}
          {item.measurement ? " " + item.measurement : item.measurement}
        </div> */}
    </Card>
  );
}

export default LargeStat;
